import React from 'react';
import { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { P } from '../../AbstractElements';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md="12" className="text-center footer-copyright">
              {/* <P attrPara={{ className: "mb-0" }}>{t("Copyright")} © {new Date().getFullYear()} NAKBHO Healthcare - Hospital Admin Panel, {t("Designed by")} NAKBHO Healthcare {t("All rights reserved")}</P> */}
              <P attrPara={{ className: "mb-0" }}>{t("All rights reserved")} {t("Copyright")} © {new Date().getFullYear()} NAKBHO HEALTHCARE - Lab Panel.</P>
            </Col>
          </Row>
        </Container>
      </footer>
    </Fragment>
  );
};

export default Footer;